app.component("cornealSutures", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/cornealSutures/cornealSutures.html",
	controller: "cornealSuturesController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("cornealSuturesController", [
	"$scope",
	function ($scope) {
		$scope.sutureOptions = [
			{ value: "NYLON_9_0", name: "9-0 Nylon" },
			{ value: "NYLON_10_0", name: "10-0 Nylon" },
			{ value: "NYLON_11_0", name: "11-0 Nylon" },
			{ value: "OTHER", name: "Other (specify)" },
		];

		$scope.techniqueOptions = [
			{ value: "KNOT_3_1_1", name: "3-1-1" },
			{ value: "KNOT_1_1_1", name: "1-1-1 (slip-knot)" },
			{ value: "KNOT_1_1_1_1", name: "1-1-1-1 (modified slip-knot)" },
			{ value: "OTHER", name: "Other (specify)" },
		];

		$scope.sutureTechniqueOptions = [
			{ value: "INTERRUPTED", name: "Interrupted" },
			{ value: "SINGLE_CONTINUOUS", name: "Single Continuous" },
			{ value: "COMBINED", name: "Combined" },
			{ value: "DOUBLE_CONTINUOUS", name: "Double Continuous" },
		];

		$scope.removeSuture = function (index) {
			$scope.$ctrl.data.corneal_suture.corneal_sutures.splice(index, 1);
		};

		$scope.addSuture = function () {
			if (!$scope.$ctrl.form.suture_type || !$scope.$ctrl.form.suture_technique) {
				return;
			}

			if (!$scope.$ctrl.data.corneal_suture.corneal_sutures) {
				$scope.$ctrl.data.corneal_suture.corneal_sutures = [];
			}
			// Only keep the values whose inputs are shown for this suture type/technique, so a value
			// typed before switching technique is not saved against the wrong one.
			const technique = $scope.$ctrl.form.suture_technique;
			const hasInterrupted = technique === "INTERRUPTED" || technique === "COMBINED";
			const hasContinuous = technique === "SINGLE_CONTINUOUS" || technique === "DOUBLE_CONTINUOUS" || technique === "COMBINED";
			$scope.$ctrl.data.corneal_suture.corneal_sutures.push({
				suture_type: $scope.$ctrl.form.suture_type,
				suture_type_other_text: $scope.$ctrl.form.suture_type === "OTHER" ? $scope.$ctrl.form.suture_type_other_text : null,
				suture_technique: technique,
				interrupted_count: hasInterrupted ? $scope.$ctrl.form.interrupted_count : null,
				continuous_bites: hasContinuous ? $scope.$ctrl.form.continuous_bites : null,
			});
			// reset fields to empty
			this.$ctrl.form.suture_type = "";
			this.$ctrl.form.suture_type_other_text = null;
			this.$ctrl.form.suture_technique = "";
			this.$ctrl.form.interrupted_count = null;
			this.$ctrl.form.continuous_bites = null;

			$scope.warn = false;
		};

		$scope.showWarn = function () {
			$scope.warn = true;
		};
	},
]);
